import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import PDFViewer from '../components/pdfViewer'
import styles from '../components/pdf-viewer.module.css'

export const query = graphql`
  query ReportTemplateQuery($id: String!) {
    sanityReport(id: { eq: $id }) {
      id
      title
      pdf {
        asset {
          url
        }
      }
      slide1 { asset { url } }
      slide2 { asset { url } }
      slide3 { asset { url } }
      slide4 { asset { url } }
      slide5 { asset { url } }
    }
  }
`

export default function ReportTemplate ({ data }) {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
    document.body.style.background = '#111'
    document.body.style.margin = '0'
    document.body.classList.add('redHead')
    return () => {
      document.body.style.background = ''
      document.body.style.margin = ''
      document.body.classList.remove('redHead')
    }
  }, [])

  const report = data?.sanityReport
  const pdfUrl = report?.pdf?.asset?.url
  const slideImages = [
    report?.slide1?.asset?.url,
    report?.slide2?.asset?.url,
    report?.slide3?.asset?.url,
    report?.slide4?.asset?.url,
    report?.slide5?.asset?.url,
  ]

  if (!isClient) return <div className={styles.darkPlaceholder} />

  return pdfUrl
    ? <PDFViewer url={pdfUrl} title={report?.title} slideImages={slideImages} />
    : <div className={styles.noData}>No PDF available.</div>
}
